import axios from "axios";
import { header } from "./header";

export const SaveGenConfig = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/SaveGeneralConfigDetails`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const getGenConfig = async (Obj) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetGeneralConfigDetails?OrgCode=${Obj.OrgCode}`,{headers:header()});
    return response;

  } catch (error) {
    return error.response;
  }
}

export const getTranExits = async (Obj) => {
  try {
    const reponse = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTransactionExist?OrgCode=${Obj.OrgCode}`,{headers:header()})
    return reponse
  }
  catch (error) {
    return error.reponse
  }
}

export const getOrgLogo = async (Obj) => {
  try {
    const reponse = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgApi/GetLogoDetails?OrgCode=${Obj.OrgCode}`,{headers:header()})
    return reponse
  }
  catch (error) {
    return error.reponse
  }
}

export const saveOrgLogo = async (Obj) => {
  try {
    const reponse = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgApi/AddLogoDetails`, Obj,{headers:header()})
    return reponse
  }
  catch (error) {
    return error.reponse
  }
}

export const UpdateBusinessType = async (obj) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/UpdateBusinessType`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const posttaxillalogout = async () => {
  try {
    const reponse = await axios.post(`${process.env.REACT_APP_TAXILA_REDIRECT}/idm/logout`,'',{headers:header()})
    return reponse
  }
  catch (error) {
    return error.reponse
  }
}

export const barcodeDisable = async (OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/BarcodeDisable?Orgcode=${OrgCode}`,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}

export const Multicurrencyvalidate = async (OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/Transaction/GetTranscurrencyValidation?Orgcode=${OrgCode}`,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}
export const saveWeighingScalePluSeries = async (obj) => {
  try {
    const reponse = await axios.post(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/SaveWeighingScalePluSeries`,obj,{headers:header()})
    return reponse
  }
  catch (error) {
    return error.response
  }
}
export const getWeighingScalePluSeriesById = async (OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetWeighingScalePluSeriesById?Orgcode=${OrgCode}`,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}
export const GetUOMConversionCount = async (OrgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SUPPLY_BASE_URL}/api/Item/GetUOMConversionCount?Orgcode=${OrgCode}`,{headers:header()})
    return response
  }
  catch (error) {
    return error.response
  }
}